import type { ReactElement } from 'react';
import { AccountsClient } from './AccountsClient';
import { AuthorisationCodes } from './AuthorisationCodes';
import { Dashboard } from './Dashboard';
import { SupportTicket } from './SupportTicket';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/dashboard': <Dashboard />,
  '/home/accountclient': <AccountsClient />,
  '/home/authorisation-codes': <AuthorisationCodes />,
  '/home/ticket': <SupportTicket />,
};
